/* eslint-disable */
import addthis from 'addthis-snippet';

export default {
  install(Vue, { addThisPubId }) {
    const config = {
      pubid: addThisPubId,
    };
    
    addthis(config, null, function () {
      window.addthis.init();
    });
  },
};



// WEBPACK FOOTER //
// ./src/modules/addThis/addThis.js